// Dependencies
import React, { Fragment, useState } from 'react';
import { injectIntl } from 'react-intl';

// Globals components
import Table, { Column, Toolbar, FilterButton } from 'Components/Table';
import { IconButton } from '@mui/material';
import DraftsIcon from '@mui/icons-material/Drafts';
import RoomIcon from '@mui/icons-material/Room';
import FlagIcon from '@mui/icons-material/Flag';

// OwnComponents
import Pill from 'Components/Pill';
import colors from 'Assets/sass/core/vars.scss';
import { useSidePanelMap } from 'Core/hooks'

const InboxTab = (props) => {
	const { messages } = props.intl;

	const [testData] = useState([
		{
			hour: "2:59 PM (10 min ago)", date: "September 19, 2020",
			label: "3.5 Test",
			unit: "9754957-3",
			severity: "low",
			location: " 33 E 24th St, National City CA 9150",
			speed: 0,
			average: 65,
			read: true
		},
		{
			hour: "1:59 PM (1 hour ago)", date: "September 19, 2020",
			label: "3.6 Test",
			driver: "Jessica Hall",
			severity: "high",
			location: " 33 E 24th St, National City CA 9150",
			speed: 77,
			average: 65,
			read: false
		},
		{
			hour: "1:59 PM (1 hour ago)", date: "September 19, 2020",
			label: "3.6 Test",
			driver: "Jessica Hall",
			severity: "medium",
			location: " 33 E 24th St, National City CA 9150",
			speed: 77,
			average: 65,
			read: true
		},
		{
			hour: "1:59 PM (1 hour ago)", date: "September 19, 2020",
			label: "3.6 Test",
			unit: "9754957-3",
			severity: "low",
			location: " 33 E 24th St, National City CA 9150",
			speed: 77,
			average: 65,
			read: true
		}
	])

	let newVehicleInMap = []
	newVehicleInMap[12] = { latitude: 36.046405, longitude: -77.0345380, direction: 35, heading: '1', Label: 'temporal' }

	const [SideMapComponent, onToggleSideMap] = useSidePanelMap()

	return (
        <Fragment>
			<Table
				data={testData}
				hideSelectableCheckbox={false}
				stickyHeader
				rowsPerPage={10}
				loading={false}
				name="services"
				exportOrientation="landscape"
				topSpaceSize={265}
			>
				<Toolbar>
					<FilterButton />
					<IconButton
                        className="flexCenter"
                        style={{ marginTop: "-4px", color: "black" }}
                        size="large">
						<DraftsIcon />
					</IconButton>
				</Toolbar>
				<Column label={messages['AlertsinboxTab_DateTime']} field="miles">
					{(alert) => {
						return (
							<div className="paddingBigCell" >
								<span><b>{alert.date}</b></span>
								<br />
								<span className="subtitle" >
									{alert.hour}
								</span>
							</div>
						);
					}}
				</Column>

				<Column label={messages['AlertsinboxTab_Label']} field="miles">
					{(alert) => {
						return (
							<div className="paddingBigCell" >
								<span>{alert.label}</span>
							</div>
						);
					}}
				</Column>

				<Column label={messages['AlertsinboxTab_Units']} field="miles">
					{(alert) => {
						return (
							<div className="paddingBigCell" >
								<span>{alert.unit && alert.unit || alert.driver && alert.driver}</span>
							</div>
						);
					}}
				</Column>

				<Column label={messages['AlertsinboxTab_Severity']} field="miles">
					{(alert) => {
						return (
							<div className="paddingBigCell" >
								{  alert.severity === "low" && (
									<Pill
										className="alerts_on_table"
										item={{ color: colors.green, name: messages['user_alerts_low_title'] }}
									/>
								)}
								{  alert.severity === "medium" && (
									<Pill
										className="alerts_on_table"
										item={{ color: colors.orange, name: messages['user_alerts_medium_title'] }}
									/>
								)}
								{  alert.severity === "high" && (
									<Pill
										className="alerts_on_table"
										item={{ color: colors.red, name: messages['user_alerts_high_title'] }}
									/>
								)}
							</div>
						);
					}}
				</Column>

				<Column label={messages['AlertsinboxTab_Location']} field="miles">
					{(alert) => {
						return (
							<div className="paddingBigCell" >
								<div>
									<div className={'inline'}>
										<RoomIcon style={{ fontSize: "16px" }} />
									</div>
									<div className={'inline'}>
										<span onClick={() => { onToggleSideMap(true, newVehicleInMap) }} className="underline"  >
											<b>{alert.location}</b>
										</span>
									</div>
								</div>
								<div className={'inline'}>
									<FlagIcon style={{ color: colors.vanilla_gray, fontSize: "12px" }} />
									<span className="landMark underline">{messages["AlertsinboxTab_None"]}</span>
								</div>
							</div>
						);
					}}
				</Column>

				<Column label={messages['AlertsinboxTab_Speed']} field="miles">
					{(alert) => {
						return (
							<div className="paddingBigCell" >
								<span style={{ color: colors.green }} >{alert.speed}</span>
								<br />
								<div >
									<span className="softBorder" >{alert.average}</span>
								</div>
							</div>

						);
					}}
				</Column>

				<Column label={messages['AlertsinboxTab_Read']} field="miles">
					{(alert) => {
						return (

							alert.read &&
							<div className="dot">
								<span className="inner-dot"></span>
							</div>

						);
					}}
				</Column>
			</Table>
			<SideMapComponent />
		</Fragment>
    );
};

export default injectIntl(InboxTab);
